import calendarInlineHeaderComponent from './calendarInlineHeader.component';

let calendarInlineHeaderModule = angular.module('vacations-absences.calendarInlineHeader', [])

.component('calendarInlineHeader', calendarInlineHeaderComponent)

.name;

export default calendarInlineHeaderModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHeader/calendarInlineHeader.js